module.exports = __webpack_public_path__ + "img/me-ascii_inverted.ffcbc510.png";